var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVaknlLgReturn = function SvgVaknlLgReturn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(9 9)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3D9B8B",
    fillRule: "nonzero",
    d: "M22 1.378v4.593H0V1.378h5.042v1.378a1.375 1.375 0 1 0 2.75 0V1.378h1.833v1.378a1.375 1.375 0 1 0 2.75 0V1.378h1.833v1.378a1.375 1.375 0 1 0 2.75 0V1.378H22z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#282828",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M.472 5.521h20.639"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 20.208,
    y: 1.378,
    stroke: "#282828",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    rx: 1.377
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#282828",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M6.417 2.756V0M11 2.756V0m4.583 2.756V0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.7,
    cy: 17.95,
    r: 1.1,
    stroke: "#F3AD05",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#282828",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M12.06 18h1.837m2.453 0h1.836"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#C6C6C6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m7.766 10.272 1.837-1.836m0 1.836L7.766 8.436M3.481 10.272l1.837-1.836m0 1.836L3.481 8.436M16.35 10.272l1.836-1.836m0 1.836L16.35 8.436M12.065 10.272l1.836-1.836m0 1.836-1.836-1.836"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#C6C6C6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m7.771 14.575 1.836-1.837m0 1.837-1.836-1.837M3.481 14.575l1.837-1.837m0 1.837-1.837-1.837M16.35 14.575l1.836-1.837m0 1.837-1.836-1.837M12.06 14.575l1.837-1.837m0 1.837-1.837-1.837M3.481 18.877l1.837-1.836m0 1.836-1.837-1.836"
  }))));
};
export default SvgVaknlLgReturn;